import { useCallback } from "react";
import { getAutomatorContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";
import useWeb3 from "../useWeb3";

const UseAutomateProject = () => {
  const web3 = useWeb3();
  const contractAddress = Environment?.automator;
  const tokenRegistryContract = getAutomatorContract(contractAddress, web3);

  const createLaunchpad = useCallback(
    async (account, formData, setLoader) => {
      if (!account) {
        throw new Error("No account connected");
      }
     let  claimsAllowedTokens  = [Environment.busd,Environment.usdc,Environment.gems,  Environment.weth];
      const { walletformData, nftFormData, saleRounds, tokenAddresses } =
        formData;
      try {
        // ============================================
        // DETERMINE ROUND FIRST (before Wei conversion)
        // ============================================

        const initialPlatformAmount = parseFloat(
          walletformData.initialPlatformAmount || "0"
        );
        const feeThreshold = parseFloat(
          walletformData?.platformFeeThreshold || "0"
        );

        let round;
        if (initialPlatformAmount === 0 && feeThreshold === 0) {
          round = 0; // Scenario 1: Standard
        } else if (initialPlatformAmount === 0 && feeThreshold > 0) {
          round = 1; // Scenario 2: Prepaid fee + threshold
        } else if (initialPlatformAmount > 0 && feeThreshold === 0) {
          round = 2; // Scenario 3: Platform takes first amount
        } else if (initialPlatformAmount > 0 && feeThreshold > 0) {
          round = 2; // Scenario 3 with both values (or could be a different round)
        }

        console.log("Round calculation:", {
          initialPlatformAmount,
          feeThreshold,
          round,
        });

        // ============================================
        // NOW CONVERT TO WEI
        // ============================================
        const initMaxCap = walletformData.initialPlatformAmount
          ? web3.utils.toWei(
              walletformData.initialPlatformAmount.toString(),
              "ether"
            )
          : "0";

        // Prepare NFT prices array
        const nftPrices =
          nftFormData.nftRequired && nftFormData.nftDetails?.length > 0
            ? nftFormData.nftDetails.map((nft) =>
                // Convert to 6 decimals instead of 18
                (parseFloat(nft.price) * 10 ** 6).toString()
              )
            : ["5000"];

        // Prepare sale round arrays
        const startTimes =
          saleRounds?.length > 0
            ? saleRounds.map((round) =>
                Math.floor(new Date(round.startDate).getTime() / 1000)
              )
            : [];

        const endTimes =
          saleRounds?.length > 0
            ? saleRounds.map((round) =>
                Math.floor(new Date(round.enddate).getTime() / 1000)
              )
            : [];

        const prices =
          saleRounds?.length > 0
            ? saleRounds.map((round) =>
                web3.utils.toWei(round.roundPrice.toString(), "ether")
              )
            : [];

        const allowedTokens =
          saleRounds?.length > 0
            ? saleRounds.map(() => [...tokenAddresses])
            : [];

        const customPrices = saleRounds.map(() =>
          Array(tokenAddresses.length).fill(0)
        );

        const convertTo6Decimals = (value) => {
          const num = parseFloat(value || "0");
          return Math.floor(num * 1000000).toString();
        };

        console.log(
          "Creating launchpad with params:",
          round?.toString(),
          walletformData.projectFundWallet,
          walletformData.platformFeeWallet,
          walletformData?.buybackBurnWallet,
          walletformData.ownerWallet,
          "10000000000000000000000000000000000000000", // initMaxCap,
          nftFormData.nftRequired,
          nftFormData.buyBackRequired,
          walletformData.platformFeeThreshold === ""
            ? "0"
            : convertTo6Decimals(walletformData.platformFeeThreshold),
          walletformData.initialPlatformAmount === ""
            ? "0"
            : convertTo6Decimals(walletformData.initialPlatformAmount),
          nftPrices,
          startTimes,
          endTimes,
          prices,
          claimsAllowedTokens,
          allowedTokens,
          customPrices
        );

        const txResponse = await tokenRegistryContract.methods
          .createLaunchpad(
            round?.toString(),
            walletformData.projectFundWallet,
            walletformData.platformFeeWallet,
            walletformData?.buybackBurnWallet,
            walletformData.ownerWallet,
            "1000000000000000000000000000", // initMaxCap,
            nftFormData.nftRequired,
            nftFormData.buyBackRequired,
            walletformData.platformFeeThreshold === ""
              ? "0"
              : convertTo6Decimals(walletformData.platformFeeThreshold),
            walletformData.initialPlatformAmount === ""
              ? "0"
              : convertTo6Decimals(walletformData.initialPlatformAmount),
            nftPrices,
            startTimes,
            endTimes,
            prices,
            claimsAllowedTokens,
            allowedTokens,
            customPrices
          )
          .send({ from: account });

        console.log("Launchpad created successfully:", txResponse);
        return txResponse;
      } catch (err) {
        console.error("Error creating launchpad:", err);
        setLoader(false);
        throw err;
      }
    },
    [tokenRegistryContract, web3]
  );

  return { createLaunchpad };
};

export default UseAutomateProject;
